import axios from '../../axios'

// 新增专业考试大类
export const addProfexam = (data) => {
    return axios({
        url: '/api/data/wish/prof/exam/category',
        method: 'POST',
        data
    })
}

// 修改专业考试大类
export const editProfexam = (data) => {
    return axios({
        url: '/api/data/wish/prof/exam/category',
        method: 'PUT',
        data
    })
}

// 获取专业考试大类详情
export const getProfexamInfo = (data) => {
    return axios({
        url: '/api/data/wish/prof/exam/category',
        method: 'GET',
        data
    })
}

// 删除专业考试大类
export const deleteProfexamList = (data) => {
    return axios({
        url: '/api/data/wish/prof/exam/category',
        method: 'DELETE',
        data
    })
}

// 获取专业考试大类列表
export const getProfexamList = (data) => {
    return axios({
        url: '/api/data/wish/prof/exam/category',
        method: 'GET',
        data
    })
}

// 导入专业考试大类
export const importProfexam = (data) => {
    return axios({
        url: '/api/data/wish/prof/exam/category/import',
        method: 'POST',
        data
    })
}

// 导出专业考试大类
export const exportProfexam = (data) => {
    return axios({
        url: '/api/data/wish/prof/exam/category/export',
        method: 'POST',
        data
    })
}

// 批量更新专业考试大类
export const updateProfexam = (data) => {
    return axios({
        url: '/api/data/wish/prof/exam/category/batch/update',
        method: 'POST',
        data
    })
}

// 批量删除专业考试大类
export const allDeleteProfexam = (data) => {
    return axios({
        url: '/api/data/wish/prof/exam/category/batch/delete',
        method: 'POST',
        data
    })
}

// 对比导出专业考试大类
export const diffExportProfexam = (data) => {
    return axios({
        url: '/api/data/wish/prof/exam/category/check',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/profexamcategory.js